import { createRouter, createWebHistory } from 'vue-router';
import AnalysisHome from '../views/AnalysisHome.vue';
import SemLanding from '../views/analysis/sem/SemLanding.vue';
import SemStep1Scale from '../views/analysis/sem/SemStep1Scale.vue';
import SemStep2Segmentation from '../views/analysis/sem/SemStep2Segmentation.vue';
import SemStep3Export from '../views/analysis/sem/SemStep3Export.vue';

const routes = [
  { path: '/', redirect: '/analysis' },
  { path: '/analysis', name: 'analysis', component: AnalysisHome },
  { path: '/analysis/sem', name: 'semLanding', component: SemLanding },
  { path: '/analysis/sem/step-1', name: 'semStep1', component: SemStep1Scale },
  { path: '/analysis/sem/step-2', name: 'semStep2', component: SemStep2Segmentation },
  { path: '/analysis/sem/step-3', name: 'semStep3', component: SemStep3Export },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;

